/*global TTApplicationEnum, GetAppInfo, _moovilaSecurity */
/*eslint no-undef: "error"*/

import React, { Component } from 'react';
import {QuestionBox } from 'moovila-common';
import axios from "axios";

class EnterpriseTunnelModal extends Component {
  constructor(props) {
    super(props);
    this.tunnel = this.tunnel.bind(this);
  }

  tunnel(openNewTab=true) {
    const app = GetAppInfo(TTApplicationEnum.ENTERPRISE_CONSOLE);
    let windowHandle;
    if (openNewTab) {
      windowHandle = window.open(null, '_blank');
    }

    const api = GetAppInfo(TTApplicationEnum.API);
    const baseUrl = api.siteURL;

     _moovilaSecurity.GetJWTToken((jwt) => {
      return axios.get(baseUrl + '/Security/CreateTunnelSession', {
      params: {userGUID: _moovilaSecurity.GetUserGUID()},
        'headers': { 'Authorization': `Bearer ${jwt}`,
                      'Content-Type': 'application/json'
        }
      }).then((res) =>{
        const url = `${app.siteURL}/?S=${res.data.sessionGUID}&J=${res.data.jwt}&E=${this.props.enterpriseGUID}`;
        if (openNewTab) {
          windowHandle.location.replace(url);
        } else {
          window.location = url;
        }
      }).catch((error) => {
        console.log(error);
      });
    });

  }

  render() {
    const enterprise = this.props.enterprises.filter(e => e.enterpriseGUID === this.props.enterpriseGUID)[0]
    const enterpriseName = enterprise ? enterprise.enterpriseName : '';
    return (
      <QuestionBox
        title='Enterprise Tunnel'
        yesTo={'/admin/enterprise-maintenance/enterprises'}
        noTo={'/admin/enterprise-maintenance/enterprises'}
        yesCallback={() => this.tunnel(true)}
      >
        <div>Would you like to tunnel to {enterpriseName}?</div>
      </QuestionBox>
    );
  }
}

export default EnterpriseTunnelModal;



// WEBPACK FOOTER //
// ./src/components/Admin/EnterpriseTunnelModal.js